import React from 'react'
import AddEditAmenities from '../components/amenities/AddEditAmenities/AddEditAmenities'

const AddAmenities = () => {
    return (
        <div className='outletConainer' style={{ backgroundColor: "#F7F7F7" }}>
            <AddEditAmenities />
        </div>
    )
}

export default AddAmenities
